export default __webpack_public_path__ + "static/Resolve-LightIta-abd2e454ec5d6d9e914f6368f9380c6e.woff2";